import { React, useState,useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";

import { phoneRegex } from '../../utils/Regex';
import { CreateDestination,getDestinationById, UpdateDestination } from '../../services/Destination.service';

import BackIcon from '../../assets/images/back_icon.svg'
import CreateIcon from '../../assets/images/create_icon.svg'

import ArrowleftIcon from "../../assets/images/arrowleft_icon.svg";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";



const EditDestination = ({ back }) => {
    debugger;
    const params = useParams();
    const navigate = useNavigate();

 if(!back)
    {
        back=()=>{navigate(`/admin/destination-management`)}
    }

    const handleClose = () => {

        resetForm();
        setErrors({});
        back(false)
    }
    const [destionationUserTypes] = useState([{
        name: "Internal",
        value: "I"
    },
    {
        name: "External",
        value: "E"
    }]);
    const [itemDetails, setItemDetails] = useState({});
    // form 

       // const dispatch = useDispatch();
    useEffect(() => {
        debugger;
        if (params.id) {
            getItemDetailsBy(params.id);
        }
        else {
            setValues({
                name: "-",
                active: true,
                userType: "E"
            });
        }
    }, [params.id]);

    const { handleBlur, handleChange, handleSubmit, values, errors, touched, resetForm, setErrors, setValues } = useFormik({
        initialValues: {
            name: "shahul",
            active:true,
            userType:"E"
        },
        validationSchema: Yup.object({
            name: Yup.string()
                .max(50, " Name must be at most 50 characters")
                .required("Name is required")
        }),
        onSubmit: async (values, { resetForm }) => {
            try {

                const payload = {
                     id: values.id,
                    name: values.name,
                    shortName: values.shortName,
                    active: values.active,
                    userType: values.userType
                }
                debugger;

                const res = await UpdateDestination(payload)

                if (res?.status === 201) {
                    toast.success(res.data?.message || "Successfully Updated")
                    resetForm();
                    setErrors({});
                    // navigate(`/admin/destination-management`)
                    back()

                } else {
                    toast.error(res?.message || res?.detail || res?.data.message);
                }
            } catch (error) {
                if (error?.message) {
                    const msg = error?.message?.split(":")?.[1]?.trim();
                    console.error(msg)


                }
                console.log(error.message);
            }
        },
    });

    //Edit code

 

    const getItemDetailsBy = async (id) => {
        try {
            const res = await getDestinationById(id);

debugger;
            if (res?.status === 200) {

                if (res?.data) {

                    const transactionData = res.data;
                    if (transactionData) {
                        const apiValues = {
                            id: transactionData.id,
                            name: transactionData.name,
                            shortName: transactionData.shortName,
                            active: transactionData.active,
                            userType: transactionData.userType,
                        };

                        console.log(apiValues);
                        setValues(
                            apiValues
                        );
                        setItemDetails(apiValues);
                        //return apiValues;
                    } else {
                        toast.error(res?.message || res?.data?.message);
                    }
                }
            }
        }
        catch (error) {
            
            if (error?.message) {
                const msg = error?.message?.split(":")?.[1]?.trim();
                // alert(msg);
                console.error(msg);
            }
            else
            {
                toast.error(error?.message || error?.detail || error?.data.message);
            }
            console.log(error.message);
        }
    }

            return (
                <div className='whiteFrame'>
                    <div className="mb_24 displayFlex alignItem_center gap12">
                        <div>
                            <button
                                className="emptyBtn"
                                type="button"
                                onClick={handleClose}
                            >
                                <img src={ArrowleftIcon} alt="ArrowleftIcon" />
                            </button>

                        </div>
                        <div>
                            <h5 className='fontSize20 fontWeight600 blackClr_text'> Edit Destination</h5>
                        </div>

                    </div>




                    <form onSubmit={handleSubmit}>
                        <div className='row'>
                            <div className="mb_24 col-md-6">
                                <label
                                    className="fontSize14 fontWeight500 blackClr_text display_block mb_8"
                                    htmlFor="fn"
                                >
                                    Name                    </label>
                                <input
                                    className="MainInput"
                                    type="text"
                                    placeholder="Enter Name"
                                    id="name"
                                    name="name"
                                    value={values.name}
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                />
                                {errors.name && touched.name ? (
                                    <p className="fontSize12 fontWeight500 errorClr_text mt_8">
                                        {errors.name}
                                    </p>
                                ) : (
                                    <></>
                                )}
                            </div>
                             <div className="mb_24 col-md-6">
                                <label
                                    className="fontSize14 fontWeight500 blackClr_text display_block mb_8"
                                    htmlFor="projectId"
                                >
                                    Destination User Type
                                </label>
                                <select
                                    className="selectMainInput"
                                    id="userType"
                                    name="userType"
                                    value={values.userType}
                                    onBlur={handleBlur}
                                     onChange={handleChange}
                                >
                                    <option value="">Select User Type</option>
                                    {destionationUserTypes.map((destination, i) => (
                                        <option key={i} value={destination.value}>
                                            {destination.name}
                                        </option>
                                    ))}
                                </select>
                                {errors.userType && touched.userType ? (
                                    <p className="fontSize12 fontWeight500 errorClr_text mt_8">
                                        {errors.userType}
                                    </p>
                                ) : (
                                    <></>
                                )}
                            </div>

                            <div className="mb_24 col-md-6">
                                <label
                                    className="fontSize14 fontWeight500 blackClr_text display_block mb_8"
                                    htmlFor="fn"
                                >
                                    Short Name                    </label>
                                <input
                                    className="MainInput"
                                    type="text"
                                    placeholder="Enter Short Name"
                                    id="shortName"
                                    name="shortName"
                                    value={values.shortName}
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                />
                                {errors.shortName && touched.shortName ? (
                                    <p className="fontSize12 fontWeight500 errorClr_text mt_8">
                                        {errors.shortName}
                                    </p>
                                ) : (
                                    <></>
                                )}
                            </div>

                        </div>
                        {/* ========= Submit Button ========= */}
                        {/* <div className='justifyContent_end displayFlex'>
                    <div> */}
                        <button type="submit" className="MainButton cyanSky_clr gap8">
                            <img className='width20px' src={CreateIcon} alt="CreateIcon" />
                            <span>Edit Destination</span>
                        </button>
                        {/* </div>
                </div> */}
                    </form>





                </div>
            )
        }

export default EditDestination